import React, { useState } from "react";
import { useNavigate } from "react-router";
import { UserApi } from "../services/user.api";
import vector from "../config/data";




export function GeolocalisationModal( { method, latitude, longitude })
{
    const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`;

    return (

        <div className="modal-container">
            <div className="container"> 
                <div className="row d-flex justify-content-center align-items-center vh-100 px-2">
                    
                    <div className="col-md-9 bg-white p-4 d-flex flex-column rounded-3">
                        <button className="btn-close btn-close-dark position-absolute end-0 me-3" style={{ top: "10px" }} aria-label="Close" onClick={ ()=>{ method ( false ) } } ></button>
                        <div className="d-flex p-4 border">
                            <iframe
                                src={mapUrl}
                                width="100%"
                                height="300"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Location Map"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}



export function PasswordModal({ method })
{
    const navigate = useNavigate();
    const user = UserApi();

    const [ inputs, setInputs ] = useState();
    
    const handleInputs = ( event ) => {
        const { name , value } =  event.target;
        setInputs( { ...inputs, [name] : value   } );
    }

    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const handleForm = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const {data} = await user.genPasswordToken(inputs);
            setIsLoading(false);
            if( data.success ){
                setStatus(1);
                navigate('/mot-de-passe-oublie');
            }  
            else{ setStatus(-1); } 
        } catch (err) { 
            setStatus(-1);
            setIsLoading(false);
        }
    }

    return (

        <div className="modal-container">
            <div className="container">
                <div className="row d-flex justify-content-center align-items-center vh-100 px-2">
                    <div className="col-lg-6 col-md-9 bg-white shadow-sm border p-4 d-flex flex-column rounded-3">
                        <button className="btn-close btn-close-dark position-absolute end-0 me-3" style={{ top: "10px" }} aria-label="Close" onClick={ ()=>{ method ( false ) } } ></button>
                        <div className="d-flex py-4 mb-2">

                          <form onSubmit={ handleForm } className="d-flex flex-column mt-2">
                            <div className="d-flex flex-column align-items-center gap-2 mb-4" > 
                              <div className="d-flex mb-1" >
                                <span className="d-flex align-items-center justify-content-center bg-white border px-3 py-2 rounded-2 shadow-sm"> 
                                    <img src={'../favicon.png'} className="" alt="Logement extérieur" style={{ width: "60px" }} />
                                </span>
                              </div>
                              <span className="fs-4 text-muted"> Cpanel - Mot de passe oublié </span>
                              <span className="text-muted text-center px-4 mb-4">
                                Saisissez votre numéro de téléphone, et nous vous enverrons un code de validation pour réinitialiser rapidement et en toute sécurité votre mot de passe. 
                              </span>
                            </div>
                            {
                              isLoading && (
                                <div className="d-flex justify-content-center align-items-center mb-3"> 
                                   <div className="spinner-border text-blue-clr" role="status" aria-label="Chargement"></div>
                                </div>
                              )
                            }
                            {
                              status === -1 && (
                                <div className="col-md-12 mb-2">
                                  <div className="alert alert-danger text-secondary">
                                    Une erreur est survenue durant le traitement. Vérifiez votre numéro puis réessayez.
                                  </div>
                                </div>
                              )
                            }
                            {/* -------------------------------- */}
                            <div className="col-md-12 mb-2"> 
                              <div className="d-flex gap-2 mb-2">
                                <select className="border input py-3 px-3 text-secondary rounded-2 " name='phoneIndex' required onChange={ handleInputs }>
                                  <option value=""> index </option>
                                  {
                                    vector.phoneIndex.map( (item, index) => (
                                       <option key={index} value={item}> {item} </option>
                                     ) )
                                  }
                                </select> 
                                <input type="number" name="phone" placeholder="Numéro de téléphone" className="w-100 border input py-3 px-3 text-muted rounded-2" required onChange={ handleInputs } />
                                <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                              </div>
                            </div>
                            {/* -------------------------------- */}
                            <button type="submit" className="btn btn-lg btn-secondary px-4 mt-2"> 
                              Soumettre <i className="bi bi-arrow-right"></i> 
                            </button> 
                    
                          </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
